export default __webpack_public_path__ + "assets/images/25f20a9b1acf1ebd437ce3e423a0eaf0.svg";